import { Route, Redirect, Switch, withRouter } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';

import ROUTES from 'consts/routing';

import UserProtectedRoute from './AuthorizationRoutes/UserProtectedRoute';
import AdminProtectedRoute from './AuthorizationRoutes/AdminProtectedRoute';
import OrganizationAdminProtectedRoute from './AuthorizationRoutes/OrganizationAdminProtectedRoute';
import UnauthorizedRoute from './AuthorizationRoutes/UnauthorizedRoute';
import Link from './Link';

export default {
  Provider: ConnectedRouter,
  UserProtectedRoute,
  AdminProtectedRoute,
  UnauthorizedRoute,
  OrganizationAdminProtectedRoute,
  Route,
  Redirect,
  Switch,
  withRouter,
  Link,
  ROUTES,
};
